var header = 'header_header__11q87so0';

export { header };
//# sourceMappingURL=header.vanilla.mjs.map
